<template>
  <transition name="mei-message-fade">
    <div v-if="show" :class="[
        'mei-message',
        type? `mei-message-${ type }` : '']">
      <span class="mei-message-con">{{text}}</span>
    </div>
  </transition>
</template>

<script type="text/babel">
const typeMap = {
  success: "success",
  info: "info",
  warning: "warning",
  error: "error"
};
export default {
  data() {
    return {
      show: false,
      text: "",
      type: ""
    };
  },
  computed: {
    iconClass() {
      return this.type ? `mei-message-icon mei-icon-${typeMap[this.type]}` : "";
    }
  }
};
</script>
<style>
.mei-message {
  position: fixed;
  border-radius: 4px;
  position: fixed;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  transition: opacity 0.3s, transform 0.4s;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 4px 12px;
  font-size: 13px;
}
.mei-message-fade-enter-active {
  transition: all 0.3s linear;
}
.mei-message-fade-leave-active {
  transition: all 0.3s linear;
}
.mei-message-fade-enter, .mei-message-fade-leave-to{
  opacity: 0;
}
</style>